import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { BaseError } from '../../helpers/BaseError';

import { SingleTestMessageSettingModel } from './../../models/contact_notification_token';

import API from '../../services/api';
import { toastService } from '../../services/toast.service';

import testMessageSettingUserKeys from './_querykeys';

export default function useSingleTestMessageCreate() {
    const queryClient = useQueryClient();
    return useMutation<
        AxiosResponse<SingleTestMessageSettingModel>,
        BaseError,
        SingleTestMessageSettingModel
    >({
        mutationFn: API.createSingleTestMessageSettingUser,
        onSuccess: (data) => {
            queryClient.invalidateQueries({
                queryKey:
                    testMessageSettingUserKeys.filteredSingleTestMessageUser({
                        push_provider_id: data.data.push_provider_id,
                    }),
            });
            queryClient.invalidateQueries({
                queryKey:
                    testMessageSettingUserKeys.filteredSingleTestMessageUser(
                        undefined,
                    ),
            });
            toastService.showSuccess('Sucessfully created.');
        },
        onError: (error) => {
            toastService.showError(`${error.message}`);
        },
    });
}
